import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, useAuth } from '../context/AppContext';
import { Swords, X, ChevronRight } from 'lucide-react';

export default function ChallengeNotificationBanner() {
  const [notifications, setNotifications] = useState([]);
  const [visible, setVisible] = useState(true);
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user?.silence_radio) return;
    api.get('/challenges/collective/notifications')
      .then(r => {
        if (r.data.notifications?.length > 0) {
          setNotifications(r.data.notifications);
        }
      })
      .catch(() => {});
  }, [user?.silence_radio]);

  const handleClick = () => {
    api.post('/challenges/collective/notifications/read').catch(() => {});
    navigate('/leaderboard');
  };

  const handleDismiss = (e) => {
    e.stopPropagation();
    api.post('/challenges/collective/notifications/read').catch(() => {});
    setVisible(false);
  };

  if (user?.silence_radio || !visible || notifications.length === 0) return null;

  const latest = notifications[0];
  const milestone = latest.milestone;

  const colorMap = {
    50: { bg: 'from-orange-600/90 to-amber-700/90', border: 'border-orange-500', pulse: 'bg-orange-400' },
    75: { bg: 'from-red-600/90 to-orange-700/90', border: 'border-red-500', pulse: 'bg-red-400' },
    100: { bg: 'from-green-600/90 to-emerald-700/90', border: 'border-green-500', pulse: 'bg-green-400' },
  };
  const colors = colorMap[milestone] || colorMap[50];

  return (
    <div
      onClick={handleClick}
      className={`relative mx-4 mb-3 p-3 rounded-xl bg-gradient-to-r ${colors.bg} border ${colors.border} cursor-pointer
        transition-all hover:scale-[1.01] active:scale-[0.99] overflow-hidden`}
      data-testid="challenge-notification-banner"
      role="button"
      tabIndex={0}
    >
      {/* Animated pulse */}
      <div className={`absolute top-0 left-0 w-full h-full ${colors.pulse} opacity-10 animate-pulse`} />

      <div className="relative flex items-center gap-3">
        <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-black/20 flex items-center justify-center">
          <Swords className="w-5 h-5 text-white" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-heading font-black text-white uppercase tracking-wide truncate">
            {latest.title}
          </p>
          <p className="text-xs text-white/80 line-clamp-2">{latest.body}</p>
        </div>
        <div className="flex items-center gap-1 flex-shrink-0">
          <ChevronRight className="w-5 h-5 text-white/80" />
          <button
            onClick={handleDismiss}
            className="ml-1 p-1 rounded-full hover:bg-white/20 transition-colors"
            data-testid="dismiss-challenge-notif"
          >
            <X className="w-4 h-4 text-white/60" />
          </button>
        </div>
      </div>
    </div>
  );
}
